import React from 'react';
import { brandWord } from '../styles';
import { Typography } from 'fronton-react';

interface BrandWordProps {
  brandName: string;
}

export const DATA_QA_BRAND_WORD = 'brand-word';

export const BrandWord: React.FC<BrandWordProps> = ({ brandName }) => {
  const firstLetter = brandName.trim().charAt(0);

  return (
    <Typography variant="h2" data-qa={DATA_QA_BRAND_WORD} color="text-secondary" className={brandWord}>
      {firstLetter}
    </Typography>
  );
};
